import { render, staticRenderFns } from "./sessionPanels.vue?vue&type=template&id=4c1f65c8&scoped=true"
import script from "./sessionPanels.vue?vue&type=script&lang=js"
export * from "./sessionPanels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1f65c8",
  null
  
)

export default component.exports